import React from 'react';
import {Tooltip} from '@mui/material';
import TagBadge from './TagBadge';

export default function TagChip({tag, voteTag, loadingTagOps, onTagClick = null}) {
    // Vote mode (Corpus / Products entity_tags): voteCount is a number and operationId marks
    // the viewer's own vote. DiTag tags (My Data / Highlights) carry no voteCount — they are
    // simple linked/unlinked toggles, so the chip hides the count and clicking removes the tag.
    const hasVotes = typeof tag.voteCount === 'number';
    const voted = Boolean(tag.operationId);
    const showCount = hasVotes;

    const tooltip = onTagClick
        ? (voteTag
            ? 'Click to browse · Ctrl/Cmd+click to remove'
            : 'Click to browse this tag')
        : hasVotes
            ? (voted ? 'You have voted for this tag' : 'Click to vote for this tag')
            : 'Click to remove this tag';

    return (
        <Tooltip title={tooltip} placement="top">
            <TagBadge
                tag={tag}
                voted={hasVotes ? voted : true}
                voteCount={showCount ? (tag.voteCount || 0) : null}
                sx={{cursor: 'pointer'}}
                onClick={(e) => {
                    e.stopPropagation();
                    if (onTagClick && !e.ctrlKey && !e.metaKey) {
                        onTagClick(tag);
                        return;
                    }
                    if (voteTag) voteTag(tag.name);
                }}
            />
        </Tooltip>
    );
}
